module.exports = __webpack_public_path__ + "static/media/Tyrrells-270x270.ebe81c65.png";